import Markdown from "./markdown"
import AuthItem from "./auth/auth-item"
import OnlineValidatorBadge from "./online-validator-badge"
import Model from "./model"
import JsonSchema_string from "./json-schema-string"
import OpenAPIVersion from "./openapi-version"

export default {
  Markdown,
  AuthItem,
  OpenAPIVersion,
  JsonSchema_string,
  model: Model,
  onlineValidatorBadge: OnlineValidatorBadge,
}
